'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function ContextMenuModel(mapModel) {
	let currentPosition;
	const self = observable(this),
		emptyContext = () => {
			currentPosition = false;
			self.dispatchEvent({});
		},
		sendContext = (evt, position) => {
			currentPosition = position;
			const context = {position: position};
			context[evt] = true;
			self.dispatchEvent('context', context);
		};
	mapModel.addEventListener('mapMoveRequested mapScaleChanged nodeSelectionChanged nodeEditRequested mapViewResetRequested', emptyContext);

	mapModel.addEventListener('contextMenuRequested', (nodeId, x, y) => sendContext('contextMenuRequested', {x: x, y: y}));

	['linkSelected', 'connectorSelected'].forEach((evt) => {
		mapModel.addEventListener(evt, (connector, position) => {
			const postfix = connector && connector.connectorEditingContext && connector.connectorEditingContext.name,
				event = (postfix && `${evt}:${postfix}`) || 'lineSelected';
			sendContext(event, position);
		});
	});


	self.showNodeStyle = () => {
		currentPosition && sendContext('showNodeStyle', currentPosition);
	};
};
